export default "__VITE_ASSET__294e1f70__"